export enum ERoutes {
  HOME = '/',
  BANK_ACCOUNT = '/cadastrar-conta-bancaria',
  SALE_CHANNEL = '/cadastrar-canal-de-venda',
  ONBOARDING = '/cadastro',
  STORE_CONFIG = '/loja/configurar',
  MY_ACCOUNT = '/minhas-contas',
  CONTRACT = '/contratos',
  AUTH_CALLBACK = '/authentication/callback',
  AUTH_CALLBACK_ONLY = '/callback',
  REGULATORY_DATA = '/dados-regulatorios',
  ID_MAGALU_MIGRATION_LOGIN = '/migracao-id-magalu-login',
  ID_MAGALU_MIGRATION_REGISTER = '/migracao-id-magalu-register',
  ID_MAGALU_PRELOGIN = '/pre-login',
  ID_MAGALU_LOGIN = '/id-magalu-login',
  IDENTITY_VALIDATE = '/validacao-identidade',
}
